// Copyright (c) 2020-2026 Life and Soft

import { toast } from "react-toastify";

import { INIT_CONFIGURATION, SET_CONFIGURATION, GET_ERRORS } from "./types";
import Server from "../utils/axios/Server";

// Set logged in user
export const initConfiguration = (configuration) => {
  return {
    type: INIT_CONFIGURATION,
    payload: configuration,
  };
};

// Updates configuration
export const setConfiguration = (configuration, projectName) => (dispatch) => {
  Server.put("/configuration", configuration, {
    params: { project: projectName },
  })
    .then(() => {
      toast.success("Configuration has been updated");
      dispatch({
        type: SET_CONFIGURATION,
        payload: configuration,
      });
    })
    .catch((err) => {
      toast.error("Configuration couldn't be updated");
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};
